module.exports = __webpack_public_path__ + "img/02-5在线安全观察.d61f35b2.png";